var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-zip"},[(_vm.showIcon)?[_c('z-icon',{attrs:{"name":"ZIP","size":"16px"}}),_vm._v("Guías.ZIP ")]:[_c('loading-spinner',{staticClass:"loading-spinner"}),_vm._v("Descargando etiquetas... ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }